<template>
  <div id="home" class="securityHome">
    <div class="main" :style="{ transform: 'scale(' + scaleX + ')' }">
      <section class="left">
        <deviceView :data="deviceData"></deviceView>
        <leftSecond :data="alarmData"></leftSecond>
        <leftThird :data="statisData"></leftThird>
      </section>
      <section class="rightMain">
        <div class="searchCon">
          <div>
            <el-form inline>
              <el-form-item label="告警日期">
                <el-select v-model="searchForm.timeType" placeholder="请选择告警日期">
                  <el-option
                    v-for="(item, index) in dateArr"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="告警类型">
                <el-select v-model="searchForm.alarmType" placeholder="请选择告警类型" clearable>
                  <el-option
                    v-for="(item, index) in typeArr"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="告警状态">
                <el-select v-model="searchForm.category" placeholder="请选择告警状态">
                  <el-option
                    v-for="(item, index) in categoryArr"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="searchBtn">
            <button class="BlueSmBtn" @click="confirmSearch">搜索</button>
            <button class="OrangeSmBtn" @click="resetData">重置</button>
          </div>
        </div>
        <div class="tableCon" v-if="!loading && tableData.length > 0">
          <div class="itemCon">
            <div class="table-item" v-for="(item, index) in tableData" :key="index">
              <div class="table-img">
                <el-image
                  :src="item.aiboxSmallImage != null ? item.aiboxSmallImage : item.aiboxBigImage"
                  class="imgs"
                  :preview-src-list="[
                    item.aiboxBigImage != null ? item.aiboxBigImage : item.aiboxSmallImage
                  ]"
                  alt="图片"
                  :initial-index="0"
                ></el-image>
              </div>
              <div class="table-con">
                <span class="title">{{ item.aiboxAlarmTypeName }}</span>
                <span class="text">时间：{{ item.startTime }}</span>
                <span class="text">设备：{{ item.deviceName }}</span>
                <span class="text">位置：{{ item.areaNames }}</span>
                <span
                  class="operation"
                  @click="openDetail(item)"
                  v-if="item.aiboxAccessUrl != null && item.aiboxAccessUrl != ''"
                  >详情</span
                >
              </div>
            </div>
          </div>
          <div class="footer tabLv3">
            <el-pagination
              layout="prev, pager, next"
              :page-size="12"
              @current-change="handleCurrentChange"
              :total="total"
              :current-page="currentPage"
            >
            </el-pagination>
          </div>
        </div>
        <div class="noData" v-if="!loading && tableData.length === 0">
          <img src="./imgs/noData.png" class="noImg" />
        </div>
        <div
          class="noData"
          v-if="loading"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
        ></div>
      </section>
    </div>
    <i
      :class="!isExpand ? 'el-icon-caret-left' : 'el-icon-caret-right'"
      class="arrow"
      @click="isExpand = !isExpand"
    ></i>
    <div class="two_code" :style="{ display: isExpand ? 'block' : 'none' }">
      <div class="two_code_top">
        <p class="scan_line"></p>
        <img v-default-img class="two_code_img" :src="imgUrl" alt />
      </div>
      <div class="two_code_bottom">
        <p style="color: #3ba1f7">扫描二维码下载手机APP</p>
      </div>
    </div>
    <el-dialog :visible.sync="detailDialog" class="detailDialog">
      <div class="dialog_con">
        <iframe
          :src="frameData.url"
          width="100%"
          height="100%"
          scrolling="auto"
          class="iframe"
          frameborder="0"
        ></iframe>
        <div class="desc">
          <span>登录用户名：{{ frameData.userName }}</span>
          <span>登录密码：{{ frameData.password }}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        scaleX: 1,
        searchForm: {
          timeType: 1,
          alarmType: '',
          name: '',
          category: 0
        },
        total: 0,
        currentPage: 1,
        dateArr: [
          {
            label: '全部',
            value: 3
          },
          {
            label: '本日',
            value: 0
          },
          {
            label: '本周',
            value: 1
          },
          {
            label: '本月',
            value: 2
          }
        ],
        typeArr: [],
        categoryArr: [
          {
            label: '实时告警',
            value: 0
          },
          {
            label: '历史告警',
            value: 1
          }
        ],
        tableData: [],
        frameData: {
          url: '',
          userName: '',
          password: ''
        },
        imgUrl: '',
        isExpand: false,
        detailDialog: false,
        loading: false,
        deviceData: {
          offline: undefined,
          online: undefined,
          total: undefined
        },
        alarmData: {
          totalNum: undefined,
          todayNum: undefined,
          weekNum: undefined,
          monthNum: undefined
        },
        statisData: {},
        refreshTimer: null
      }
    },
    components: {
      deviceView: () => import('./components/deviceView/index.vue'),
      leftSecond: () => import('./components/leftSecond'),
      leftThird: () => import('./components/leftThird')
    },
    methods: {
      refreshData() {
        clearInterval(this.refreshTimer)
        this.refreshTimer = null
        this.refreshTimer = setInterval(() => {
          this.getStatisData()
          this.getListData()
        }, 300000)
      },
      getStatisData() {
        this.$axiosget('operation/deviceAlarmApi/aiboxStatis').then(res => {
          if (res.data.status === '10000') {
            this.deviceData.offline = res.data.data.offline || 0
            this.deviceData.online = res.data.data.online || 0
            this.deviceData.total = res.data.data.total || 0
            this.alarmData.todayNum = res.data.data['day'].num || 0
            this.alarmData.weekNum = res.data.data['week'].num || 0
            this.alarmData.monthNum = res.data.data['month'].num || 0
            this.alarmData.totalNum = res.data.data['all'].num || 0
            const { all, day, week, month } = res.data.data
            this.statisData = { all, day, week, month }
          }
        })
      },
      getDictData() {
        this.$axiosget('operation/dictionaryType/queryByKey', {
          params: {
            key: 'aiboxAlarmType'
          }
        }).then(res => {
          if (res.data.status === '10000') {
            this.typeArr = res.data.data ? res.data.data.list : []
          }
        })
      },
      resetData() {
        this.searchForm.timeType = 1
        this.searchForm.alarmType = ''
        this.searchForm.name = ''
        this.searchForm.category = 0
      },
      confirmSearch() {
        this.currentPage = 1
        this.getListData()
        this.refreshData()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getListData()
        this.refreshData()
      },
      getListData() {
        this.loading = true
        this.$axiosget('operation/deviceAlarmApi/aiboxAlarmDataPage', {
          params: {
            alarmType: this.searchForm.alarmType,
            timeType: this.searchForm.timeType !== 3 ? this.searchForm.timeType : undefined,
            isHistory: this.searchForm.category,
            pageNum: this.currentPage,
            pageSize: 12
          }
        }).then(
          res => {
            this.loading = false
            if (res.data.status === '10000') {
              this.tableData = res.data.data
                ? res.data.data.list.map(item => {
                    return {
                      ...item,
                      aiboxSmallImage:
                        item.aiboxSmallImage != null
                          ? item.aiboxSmallImage.indexOf('operation') != -1
                            ? process.env.API_HOST + item.aiboxSmallImage
                            : 'data:image/jpeg;base64,' + item.aiboxSmallImage
                          : null,
                      aiboxBigImage:
                        item.aiboxBigImage != null
                          ? item.aiboxBigImage.indexOf('operation') != -1
                            ? process.env.API_HOST + item.aiboxBigImage
                            : 'data:image/jpeg;base64,' + item.aiboxBigImage
                          : null
                    }
                  })
                : []
              this.total = res.data.data.total
            }
          },
          () => {
            this.loading = false
          }
        )
      },
      openDetail(item) {
        this.frameData.url = `http://${item.aiboxAccessUrl}/#/login`
        this.frameData.userName = item.aiboxAccessUser
        this.frameData.password = item.aiboxAccessPwd
        this.detailDialog = true
      }
    },
    mounted() {
      this.getStatisData()
      this.getListData()
      this.getDictData()
      this.imgUrl = process.env.API_HOST + 'operation/jpg/aiboxApkCode.png'
      this.scaleX = $('#app').width() / 1920
      window.onresize = () => {
        this.scaleX = $('#app').width() / 1920
      }
      this.refreshTimer = setInterval(() => {
        this.getStatisData()
        this.getListData()
      }, 300000)
    },
    beforeDestroy() {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    }
  }
</script>

<style lang="less" scoped>
  .securityHome {
    width: 100%;
    height: 100%;
    margin-left: -20px;
    .main {
      width: 1920px;
      height: 936px;
      padding: 20px;
      display: flex;
      transform-origin: top left;
      background: none !important;
    }

    .left {
      width: 432px;
      position: relative;
      opacity: 1;
    }

    .rightMain {
      margin-left: 15px;
      width: calc(100% - 432px - 15px);
      height: 100%;
      overflow: auto;

      .searchCon {
        background: transparent;
        box-shadow: 0px 0px 20px 3px #185694b9 inset;
        border: 1px solid #3b4c75;
        display: flex;
        justify-content: space-between;
        padding: 15px 20px 0;
        height: 72px;

        /deep/ .el-form .el-form-item .el-form-item__content .el-input .el-input__inner {
          background: #2d477d;
          border-color: transparent;
        }

        .el-form-item {
          margin-right: 20px;
        }

        .searchBtn {
          float: right;
          padding-top: 5px;

          .OrangeSmBtn {
            margin-left: 15px;
          }
        }
      }

      .tableCon {
        height: calc(100% - 74px - 20px);
        .itemCon {
          margin-top: 20px;
          width: 100%;
          height: calc(100% - 50px);
          // overflow: auto;
          display: flex;
          flex-wrap: wrap;
          align-items: flex-start;
          align-content: flex-start;
        }

        .table-item {
          width: calc((100% - 46px) / 3);
          height: 170px;
          display: flex;
          align-items: center;
          margin-bottom: 19px;

          &:nth-child(3n + 2) {
            margin-left: 23px;
            margin-right: 23px;
          }

          .table-img {
            width: 252px;
            height: 170px;
            font-size: 0;

            .imgs {
              width: 100%;
              height: 100%;
            }
          }

          .table-con {
            width: calc(100% - 252px);
            height: 100%;
            display: flex;
            background: rgba(0, 0, 0, 0.3);
            flex-direction: column;
            justify-content: center;
            padding: 0 24px;

            .title {
              font-family: 'MicrosoftYaHei-Bold';
              font-weight: bold;
              font-size: 14px;
              color: #3ba1f7;
              margin-bottom: 10px;
            }

            .text {
              font-family: 'MicrosoftYaHei';
              font-size: 12px;
              color: #fff;
              margin-bottom: 10px;
            }

            .operation {
              font-family: 'MicrosoftYaHei';
              font-size: 12px;
              color: #2d96ff;
              cursor: pointer;
            }
          }
        }

        .footer {
          width: 100%;
          display: flex;
          justify-content: center;
          background: transparent;

          /deep/ .el-pagination {
            padding: 0;
            margin-top: 22px;
          }
        }
      }

      .noData {
        height: calc(100% - 74px - 30px);
        display: flex;
        justify-content: center;
        align-items: center;

        .noImg {
          width: 200px;
          height: auto;
        }
      }
    }

    .arrow {
      position: fixed;
      font-size: 0.3rem;
      font-weight: bold;
      color: #3ba1f7;
      cursor: pointer;
    }

    .el-icon-caret-right {
      right: -0.05rem;
      bottom: 2.69rem;
    }

    .el-icon-caret-left {
      right: -0.05rem;
      bottom: 2.69rem;
    }

    .two_code {
      position: fixed;
      right: 0.13rem;
      bottom: 1.42rem;
      width: 2.11rem;
      background-color: rgba(33, 55, 100, 0.8);
      border: 0.01rem solid rgba(98, 129, 202, 0.8);
      transition: all 0.3s;
      .two_code_top {
        padding: 0.3rem 0.38rem 0.33rem;
        height: 1.98rem;
        position: relative;

        .two_code_img {
          width: 1.35rem;
          height: 1.35rem;
        }

        .scan_line {
          position: absolute;
          width: 1.35rem;
          height: 0.08rem;
          background-image: radial-gradient(#00a3c6, transparent);
          animation: scan 3s ease-in-out infinite alternate;
        }

        @keyframes scan {
          0% {
            top: 0.3rem;
          }
          100% {
            top: 1.58rem;
          }
        }
      }
      .two_code_bottom {
        height: 0.54rem;
        background-color: #2d477d;
        border-bottom: 0.01rem solid #3f434a;
        border-left: 0.01rem solid #3f434a;
        border-right: 0.01rem solid #3f434a;

        p {
          font-family: 'MicrosoftYaHei-Bold';
          font-size: 0.14rem;
          line-height: 0.54rem;
          text-align: center;
        }
      }
    }
  }

  .imgCon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-bottom: 20px;

    .el-image {
      width: 800px;
      height: auto;
    }
  }

  /deep/ .detailDialog {
    .el-dialog {
      position: relative;
      width: 92vw !important;
      height: 90vh !important;
      padding-bottom: 0;
      margin-top: 4vh !important;
      overflow: hidden;

      .el-dialog__body {
        height: calc(100% - 52px);
        padding: 20px;

        .dialog_con {
          position: relative;
          height: 100%;

          .desc {
            text-align: center;
            position: absolute;
            right: 1.96rem;
            top: 0.1rem;
            font-size: 0.15rem;
            font-weight: bold;
            color: #000;

            span:last-child {
              margin-left: 0.1rem;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute1/securityHome/index.vue